import {
  FETCH_ALL_SUBSCRIBER,
  FETCH_PAGINATED_SUBSCRIBER,
} from './../../mutation-types';

export default {
  [FETCH_ALL_SUBSCRIBER](state, subscriber) {
    state.all = subscriber;
  },

  [FETCH_PAGINATED_SUBSCRIBER](state, { subscriber, pagination }) {
    state.items = subscriber;
    state.pagination = pagination;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/subscriber/mutations.js